export const paymentColorMixin = {
    methods: {
        getStatusColor(status) {
            if (status === "finished") {
                return "#4CAF50";
            } else if (["failed", "cancelled"].includes(status)) {
                return "#FF0000";
            } else if (status === "waiting") {
                return "#999999";
            } else if (status === "expired") {
                return "#0066ff";
            } else if (status === "started") {
                return "#eec01f";
            } else if (status === "inactive") {
                return "#af00ac";
            } else if (status === "partial") {
                return "#c46600";
            } else {
                return "#999999";
            }
        }
    }
};
